import { DateOnly } from '@if/core/date'
import { ESourceSystem } from '@if/core/types'
import * as yup from '@if/core/yup'

export interface Ban {
  id: string
  firstName: string
  lastName: string
  birthDate: DateOnly
  sin: string
  reason: string
  expirationDate: DateOnly | null
  sourceSystem: ESourceSystem | ''
}

export interface BanishmentFilterForm {
  firstName: string | null
  lastName: string | null
  birthDate: Date | null
  sin: string | null
  isMonolith: boolean
}

export interface BanishmentFilter {
  firstName: string | null
  lastName: string | null
  birthDate: Date | null
  sin: string | null
  sourceSystem: ESourceSystem | null
}

export const PROTECTED_BANNED_TEST_CASE = {
  firstName: 'ALBERT',
  lastName: 'BANNED',
  birthDate: '1965-01-01',
} as const

export function isProtectedBannedTestCase(ban: Ban): boolean {
  return (
    ban.firstName.toUpperCase() === PROTECTED_BANNED_TEST_CASE.firstName &&
    ban.lastName.toUpperCase() === PROTECTED_BANNED_TEST_CASE.lastName &&
    ban.birthDate.toString() === PROTECTED_BANNED_TEST_CASE.birthDate
  )
}

export const banishmentFormSchema = yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  birthDate: yup.dateOnly().required(),
  sin: yup.string().validSIN().defined(),
  reason: yup.string().required(),
  expirationDate: yup.dateOnly().nullable().defined(),
})
export type BanishmentForm = yup.InferType<typeof banishmentFormSchema>
